import * as ackeeTracker from 'ackee-tracker';

const UNKNOWN_USER = "unknown";
const instance = ackeeTracker.create("//ackee.py2fun.com");
const timerCache = {};
const eventKeys = {
  // === PC 端 ===
  pcVipShowPage: "dc3128f9-0fa7-4a17-ba88-dcab726156fb",
  pcVipShowPurchaseModal: "78c13ffd-3a3e-4a14-adcc-6d086b3e0895",
  pcAptitudeTestStart: "270fc1c2-00fd-45f3-a3c7-b6fabc6784f0",
  pcAptitudeTestFinish: "7b731bc5-d516-4d0c-8a45-5376b2b3c5a3",
  // === PC 端 END ===
  // === 移动端 ===
  mobileVipShowPage: "24193fda-b8c5-44e2-85a1-c41c90831ea4",
  mobileVipPurchaseSucceed: "0701b8dc-91ac-4eb1-b1b9-bd9b577f1f80",
  mobileVipPurchaseCanceled: "bd096363-8557-449d-887a-cbae6c8a0e3e",
  mobileVipClickPurchase: "ee6073f8-12a5-4f08-8741-631508c4e5a6",
  mobileCoursePurchaseSucceed: "f7c343f5-478f-4ace-a954-d96ff49da95f",
  mobileCoursePurchaseCanceled: "5d9ad055-3e4d-42f1-91ee-6f6d2f363785",
  mobileCourseShowPage: "5fc2de98-2e29-4241-aab6-2ffc3031a178",
  mobileCourseClickPurchase: "7f39fdd7-5640-49bf-9a3e-dfe3bb84d16f",
  mobileMinePageClickVipButton: "fd99b40c-0340-4adc-8fe2-486846000cac",
  mobileAptitudeTestStart: "e6215772-fd6c-48bf-a177-315373f3e346",
  mobileAptitudeTestFinish: "01d60c85-dfec-4921-802b-7c54c229627c",
  // === 移动端 END ===
  // === 公共 ===
  clickProblemSetVipButton: "ab60b778-a955-46e1-a43e-d36459e85d27"
  // === 公共 END ===
};
// 事件配置: https://ackee.py2fun.com/#/settings
const tracker = {
  // 通用事件
  sendEvent(eventName, eventBody) {
    if (timerCache[eventName]) {
      return;
    }
    instance.action(eventKeys[eventName], {
      key: "user-" + (eventBody.userId || UNKNOWN_USER),
      value: 1
    });
    // 同一事件一段时间内只能触发一次，避免状态变化导致重复触发
    timerCache[eventName] = true;
    setTimeout(() => {
      timerCache[eventName] = false;
    }, 5000);
  }
};

export { tracker as default };
//# sourceMappingURL=index.js.map
